import User from '@/types/account/user'

export default class UserState {
    public user: User | null = null
    public authenticationError: string | null = null
}
